
(function() {
  var result = { translations: { "hr": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min.", "days": "{{ days }} dana", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, lok. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "hr": "static-7.1130"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1130",
    "ar-eg": "static-7.1130",
    "bg": "static-7.1130",
    "bn": "static-7.1130",
    "ca-es": "static-7.1130",
    "cs": "static-7.1130",
    "da": "static-7.1130",
    "de": "static-7.1130",
    "el": "static-7.1130",
    "en-gb": "static-7.1130",
    "en": "static-7.1130",
    "es-mx": "static-7.1130",
    "es": "static-7.1130",
    "et": "static-7.1130",
    "fi": "static-7.1130",
    "fr-ca": "static-7.1130",
    "fr": "static-7.1130",
    "he-il": "static-7.1130",
    "hi": "static-7.1130",
    "hr": "static-7.1130",
    "hu": "static-7.1130",
    "id": "static-7.1130",
    "it": "static-7.1130",
    "ja": "static-7.1130",
    "ko": "static-7.1130",
    "lt": "static-7.1130",
    "ms": "static-7.1130",
    "nl": "static-7.1130",
    "no": "static-7.1130",
    "pl": "static-7.1130",
    "pt-br": "static-7.1130",
    "pt-pt": "static-7.1130",
    "ro": "static-7.1130",
    "ru": "static-7.1130",
    "sk": "static-7.1130",
    "sl": "static-7.1130",
    "sv": "static-7.1130",
    "th": "static-7.1130",
    "tl": "static-7.1130",
    "tr": "static-7.1130",
    "uk": "static-7.1130",
    "vi": "static-7.1130",
    "x-pseudo": "static-7.1130",
    "zh-cn": "static-7.1130",
    "zh-hk": "static-7.1130",
    "zh-tw": "static-7.1130"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hr', {version: 'static-7.1130'}); }
})();


